import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ExternalLink from './icon-external-link.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ExternalLink {...validProps} />;
}
SvgComponent.iconName = 'external-link';

/**
 * @deprecated This is a legacy icon
 */
export const ExternalLinkIcon = svgIconWrapper(SvgComponent);
